module.exports = __webpack_public_path__ + "media/promo/lum2021/images/lh-53df62105f0266d7cd38cf0a5538cf3f.jpg";